import type { UsePaginatedQueryProps } from 'src/shared/hooks/usePaginatedQuery';

import { usePaginatedQuery } from 'src/shared/hooks/usePaginatedQuery';

import type { TCompany } from '../types';

type UseGetCompaniesProps = Omit<
  UsePaginatedQueryProps<TCompany>,
  'queryKey' | 'queryKeyForItem' | 'url'
>;

export const useGetCompanyList = ({
  urlParams,
  ...props
}: UseGetCompaniesProps = {}) =>
  usePaginatedQuery<TCompany>({
    queryKey: ['organization', 'companies'],
    url: '/organization/companies/',
    urlParams: { paginate: false, ...urlParams },
    ...props,
  });
